import {Item} from '../../item/Item';

 export class Puzzle extends Item {
    // public type: string;
    constructor(collection:any){
        super(collection);
        this.type = collection.type;
    }
}